export default function CloseIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="48"
			height="49"
			viewBox="0 0 48 49"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				y="0.0930176"
				width="48"
				height="48"
				rx="24"
				fill="currentColor"
				fill-opacity="0.06"
			/>
			<path
				d="M19 19.3086L29.4813 28.4627"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="bevel"
			/>
			<path
				d="M29.2822 19.093L19.1929 28.6774"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="bevel"
			/>
		</svg>
	);
}
